module.exports = __webpack_public_path__ + "img/no-image.59c0934d.png";